// account-menu.js — Konto-Knopf (Avatar) mit Menü „Bereiche · Profil · Abmelden“, überall an derselben Stelle.
//   mountAccount(slot, { me, current, profileUrl })  — me aus /api/me (enthält areas), current = id des Bereichs
import { html, render } from '../core/h.js';
import { openMenu } from './menu.js';
import { t } from '../../shared/i18n.js';
import { accountItems, languageItems, initials } from '../../shared/account.js';
import { readLanguages, chooseLanguage } from '../../shared/language.js';

export function mountAccount(slot, { me, current, profileUrl }) {
  if (!slot || !me) return;
  render(slot, html`<button type="button" class="vc-icon-btn vc-account" data-account aria-haspopup="menu" aria-expanded="false" aria-label="${t('ui.acct_menu')}">
    ${me.avatar_url ? html`<img class="vc-account-img" src="${me.avatar_url}" alt="">` : html`<span class="vc-account-ini" aria-hidden="true">${initials(me)}</span>`}
  </button>`);
  const btn = slot.querySelector('[data-account]');
  const languages = readLanguages();
  const pickLanguage = () => openMenu(btn, languageItems(languages), {
    label: t('ui.acct_lang_title'),
    onSelect: (code) => { if (code && !(languages.manuell ? code === languages.lang : code === 'auto')) chooseLanguage(code); },
  });
  btn.addEventListener('click', () => openMenu(btn, accountItems(me, { current, profileUrl, languages }), {
    label: t('ui.acct_menu'),
    onSelect: (href, it) => {
      if (!href) return;
      // Nach dem Schließen des ersten Menüs öffnen, sonst fängt dessen Aufräumen den Fokus ab
      if (href === '#lang') { setTimeout(pickLanguage, 0); return; }
      if (it && it.newTab) window.open(href, '_blank', 'noopener'); else location.href = href;
    },
  }));
}
